export const FLAG_GETTING_ITINERARY_SCHEDULES =
  'FLAG_GETTING_ITINERARY_SCHEDULES';
export const GET_ITINERARY_SCHEDULES = 'GET_ITINERARY_SCHEDULES';
export const CLEAR_ITINERARY_SCHEDULES = 'CLEAR_ITINERARY_SCHEDULES';
export const GET_ITINERARY_SCHEDULE = 'GET_ITINERARY_SCHEDULE';
export const CLEAR_ITINERARY_SCHEDULE = 'CLEAR_ITINERARY_SCHEDULE';
export const FLAG_ITINERARY_SCHEDULE_ACTIVITY =
  'FLAG_ITINERARY_SCHEDULE_ACTIVITY';
